import { getDecodedToken } from "./authToken";

// ALWAYS use this everywhere
export const getTenant = (): string | null => {
  const local = localStorage.getItem("tenantId");

  if (local && local !== "null" && local !== "undefined") {
    return local;
  }

  //  fallback to token
  const decoded = getDecodedToken();
  return decoded?.tenant_id ?? null;
};

export const setTenant = (tenantId: string) => {
  localStorage.setItem("tenantId", tenantId);
};

export const clearTenant = () => {
  localStorage.removeItem("tenantId");
};